var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"supplier_scoring"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-4 col-lg-4"},[_c('supplier-survey-feedback',{attrs:{"SupplierID":_vm.SupplierId}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }